// extracted by mini-css-extract-plugin
module.exports = {"container":"_2GzW_ybxvh5_Iaz_13k5rg","icon":"jU8yrqJmCL7MQU4WEABeA"};